import React, { HTMLAttributes } from "react";
import cn from "classnames";

const TrustBox: React.FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => {
  const [scriptError, setScriptError] = React.useState(false);

  React.useEffect(() => {
    const script = document.createElement("script");

    script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.onerror = () => setScriptError(true);

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      {...rest}
      className={cn("trustpilot-widget", className)}
      data-locale="en-GB"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="6392287740b116458553ed83"
      data-style-height="150px"
      data-style-width="100%"
    >
      {scriptError && (
        <a
          href="https://uk.trustpilot.com/review/better.co.uk"
          target="_blank"
          rel="noreferrer noopener"
        >
          Trustpilot
        </a>
      )}
    </div>
  );
};

export default TrustBox;
